import { render, staticRenderFns } from "./NgtorchOverrideBanner.vue?vue&type=template&id=54f367d3&"
import script from "./NgtorchOverrideBanner.vue?vue&type=script&lang=js&"
export * from "./NgtorchOverrideBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports